<template>
    <request-table-inns
        @input="$emit('input', $event)"
        @paginate="setPage"
        @sort="setSort"
        @filter="filterByRegion"
        :value="value"
        :regions="filterRegions"
        :is-searching="isFetching"
        :is-individual="isIndividual"
        :sort="sort"
        :records="paginatedRecords"
        :total="totalRecords"
        :display="display"
        :page="page"
    >
        <slot></slot>
    </request-table-inns>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import RequestTableInns from './RequestTableInns.vue';

export default {
    name: 'request-table-inns-container',
    props: {
        value: Object,
        isIndividual: Boolean,
    },
    components: {
        RequestTableInns,
    },
    methods: {
        ...mapActions('requestTableInns', [
            'setPage',
            'setSort',
            'resetState',
            'filterByRegion',
        ]),
    },
    computed: {
        ...mapState('requestTableInns', ['page', 'display', 'sort', 'isFetching', 'records']),
        ...mapGetters('requestTableInns', ['paginatedRecords', 'totalRecords']),

        filterRegions() {
            return ['Все регионы'].concat(this.records.map((record) => record.region));
        }
    },
    destroyed() {
        this.resetState();
    },
}
</script>



// WEBPACK FOOTER //
// RequestTableInnsContainer.vue?7feb6239